<template>
  <div>
    <q-btn
      label="Adicionar Responsáveis"
      color="blue"
      no-caps
      outline
      dense
      class="btn"
      flat
      icon="add_circle_outline"
      :disable="disabled"
      @click="disabled ? $event.stopPropagation() : (incluir = !incluir)"
    />

    <div v-if="incluir">
      <div
        class="row col-12 q-mt-lg q-ml-md container-input text-brand-5 text-weight-bold"
      >
        <q-form
          class="row col-12 q-gutter-x-lg container-nowrap"
          ref="responsavelForm"
        >
          <div class="col-lg-4 col-xs-6">
            <div class="titulo-input">Tipo Responsável</div>
            <q-select
              dense
              outlined
              class="select-btn"
              v-model="responsavel.tipo"
              :options="tipoResponsavel"
              option-label="label"
              option-value="value"
              map-options
              behavior="menu"
              @update:modelValue="tipoResponsavelAlterado"
              placeholder="Selecione um tipo"
            />
          </div>

          <div
            class="col-2 col-md-2 col-xs-4 q-mt-lg"
            v-if="responsavel.tipo.terceirizado"
          >
            <q-checkbox
              label="Terceirizado"
              class="checkbox"
              :rules="[(val) => val || 'Campo Obrigatório']"
              v-model="responsavel.terceirizado"
            />
          </div>

          <div v-if="!responsavel.terceirizado" class="col-lg-6 col-xs-6">
            <select-component
              :unidade="unidade"
              @selectValue="injectFuncionario"
              :label="'Responsável'"
            />
          </div>
          <div v-if="responsavel.terceirizado" class="col-lg-4 col-xs-4">
            <select-component-parceiros
              @selectValue="injectParceiro"
              :label="'Nome Empresa'"
              :unidadeId="unidade"
            />
          </div>
          <div
            class="col-md-2 col-xs-5"
            v-show="responsavel.terceirizado && parceiro"
          >
            <select-component-terceiros
              @selectValue="injectTerceiro"
              :unidade="unidade"
              :parceiro="parceiro"
              :label="'Nome Parceiro'"
            />
          </div>
          <div class="col-md-3 col-xs-3">
            <p></p>
            <q-btn
              class="q-mt-sm btn-acao"
              label="Confirmar"
              no-caps
              dense
              color="positive"
              icon="check_circle_outline"
              :loading="isValidating"
              @click="adicionarResponsavel"
            />
          </div>
        </q-form>
      </div>
    </div>

    <StatusEpiModal
      v-model="showEpiDialog"
      :message="epiDialogProps.message"
      :epi-items="epiDialogProps.epiItems"
      :is-blocked="epiDialogProps.isBlocked"
      :has-critical-items="epiDialogProps.hasCriticalItems"
      @confirm="handleEpiDialogConfirm"
      @cancel="handleEpiDialogCancel"
    />
  </div>
</template>

<script>
import { ref } from "@vue/reactivity";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import SelectComponent from "./SelectComponent.vue";
import { inject, watch } from "vue";
import SelectComponentTerceiros from "./SelectComponentTerceiros.vue";
import SelectComponentParceiros from "./SelectComponentParceiros.vue";
import { useEpiValidation } from "@/composables/useEpiValidation.js";
import StatusEpiModal from "@/components/StatusEpiModal.vue";

export default {
  props: ["ptId", "unidade", "disabled", "editingResponsavel"],
  emits: ["closing"],
  components: {
    SelectComponent,
    SelectComponentTerceiros,
    SelectComponentParceiros,
    StatusEpiModal,
  },
  setup(props, { emit }) {
    const store = useStore();
    const quasar = useQuasar();
    const keycloak = inject("keycloak");
    let parceiro = ref(null);
    let empresaTerceiro = ref(null);
    const incluir = ref(false);
    const responsavelForm = ref(null);
    let tipoResponsavel = ref([]);

    const { validateUserForInclusion, loading: isValidating } =
      useEpiValidation();
    const showEpiDialog = ref(false);
    const epiDialogProps = ref({});
    const pendingExecution = ref(null);

    let responsavel = ref({
      tipo: "",
      terceirizado: false,
      matricula: "",
      nome: "",
      userId: null,
      cargo: null,
    });

    if (props.editingResponsavel) {
      incluir.value = true;
      responsavel.value = {
        ...responsavel.value,
        matricula: props.editingResponsavel.matricula || "",
        nome: props.editingResponsavel.nome || "",
        terceirizado: props.editingResponsavel.terceirizado || false,
        cargo: props.editingResponsavel.cargo || null,
        userId: props.editingResponsavel.userId || null,
      };
    }

    const listarTipoResponsaveis = async () => {
      let array = [];
      try {
        let resposta = await store.dispatch("pdt/listarTiposResponsaveis", {
          unidadeId: props.unidade,
        });

        array = resposta.data.resultado.dados;

        array.forEach((e) => {
          if (e.tipo != "emissor") {
            tipoResponsavel.value.push({
              value: e.tipoReponsavelId,
              label: e.tipo,
              terceirizado: e.terceirizado,
            });
          }
        });
      } catch (error) {
        console.error(error);
      }
    };

    const injectFuncionario = async (value, funcionarioData) => {
      if (!value) return;

      let data = value.split("-");
      responsavel.value.matricula = data[1]?.trim() || "";
      responsavel.value.nome = data[0]?.trim() || "";
      responsavel.value.cargo = funcionarioData?.cargo || null;

      if (funcionarioData?.userId) {
        responsavel.value.userId = funcionarioData.userId;
      } else {
        console.error("ATENÇÃO: Nenhum userId encontrado!", funcionarioData);
      }
    };

    const injectParceiro = async (value) => {
      parceiro.value = value;
      empresaTerceiro.value = value.split(" - ")[2];
    };

    const injectTerceiro = async (value) => {
      responsavel.value.nome = value.split("-")[0];
      responsavel.value.matricula = value.split("-")[1];
    };

    const handleEpiDialogConfirm = async () => {
      showEpiDialog.value = false;
      if (pendingExecution.value) {
        await pendingExecution.value();
        pendingExecution.value = null;
      }
    };

    const handleEpiDialogCancel = () => {
      showEpiDialog.value = false;
      pendingExecution.value = null;
    };

    const executeAddResponsavel = async () => {
      try {
        if (responsavel.value.terceirizado == true) {
          await store.dispatch("pdt/adicionarResponsavelPt", {
            ptId: props.ptId,
            sap: responsavel.value.sap,
            matricula: responsavel.value.matricula,
            nome: responsavel.value.nome,
            empresa: empresaTerceiro.value,
            tipo: responsavel.value.tipo.label,
            terceirizado: responsavel.value.terceirizado,
            tipoId: responsavel.value.tipo.value,
            cargo: responsavel.value.cargo,
          });
        } else {
          await store.dispatch("pdt/adicionarResponsavelPt", {
            ptId: props.ptId,
            sap: responsavel.value.sap,
            matricula: responsavel.value.matricula,
            nome: responsavel.value.nome,
            empresa: keycloak.realm,
            tipo: responsavel.value.tipo.label,
            terceirizado: responsavel.value.terceirizado,
            tipoId: responsavel.value.tipo.value,
            cargo: responsavel.value.cargo,
          });
        }

        quasar.notify({
          message: "Responsavel adicionado a pt",
          color: "positive",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        incluir.value = false;
        emit("closing");
      } catch (error) {
        let message = "Ocorreu um erro ao adicionar responsavel a pt";
        if (error.response) {
          message = error.response.data.erro.mensagem;
        }
        quasar.notify({
          message,
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const executeEditResponsavel = async () => {
      try {
        await store.dispatch("pdt/editarResponsavelPt", {
          ptId: props.ptId,
          responsavelId: props.editingResponsavel.responsavelId,
          matricula: responsavel.value.matricula,
          nome: responsavel.value.nome,
          empresa: responsavel.value.terceirizado
            ? empresaTerceiro.value
            : keycloak.realm,
          terceirizado: responsavel.value.terceirizado,
          cargo: responsavel.value.cargo,
        });

        quasar.notify({
          message: "Responsável atualizado com sucesso",
          color: "positive",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        incluir.value = false;
        emit("closing");
      } catch (error) {
        let message = "Ocorreu um erro ao atualizar responsável";
        if (error.response) {
          message = error.response.data.erro.mensagem;
        }
        quasar.notify({
          message,
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const adicionarResponsavel = async () => {
      const valido = responsavelForm.value.validate();
      if (!valido) {
        return;
      }

      if (responsavel.value.nome == "" || responsavel.value.matricula == "") {
        return;
      }

      try {
        if (!responsavel.value.terceirizado && responsavel.value.userId) {
          const validationResult = await validateUserForInclusion(
            responsavel.value.userId,
            props.unidade,
            responsavel.value.terceirizado
          );

          if (!validationResult.canInclude) {
            epiDialogProps.value = {
              message: validationResult.message,
              epiItems: validationResult.epiData || [],
              isBlocked: true,
              hasCriticalItems: validationResult.hasCriticalItems || false,
            };
            showEpiDialog.value = true;
            return;
          } else if (validationResult.showWarning) {
            epiDialogProps.value = {
              message: validationResult.message,
              epiItems: validationResult.epiData || [],
              isBlocked: false,
              hasCriticalItems: validationResult.hasCriticalItems || false,
            };

            pendingExecution.value = props.editingResponsavel
              ? executeEditResponsavel
              : executeAddResponsavel;
            showEpiDialog.value = true;
            return;
          }
        } else if (!responsavel.value.terceirizado) {
          console.error(
            "ATENÇÃO: Funcionário não terceirizado mas sem userId!"
          );
        }

        if (props.editingResponsavel) {
          await executeEditResponsavel();
        } else {
          await executeAddResponsavel();
        }
      } catch (error) {
        console.error("Erro nas validações:", error);
        quasar.notify({
          message: "Erro ao validar funcionário. Tente novamente.",
          color: "negative",
        });
      }
    };

    watch(
      () => responsavel.value.tipo,
      () => {
        responsavel.value.terceirizado = false;
      }
    );

    watch(
      () => props.unidade,
      (newUnidadeId) => {
        if (newUnidadeId) {
          listarTipoResponsaveis();
        }
      },
      { immediate: true }
    );

    const tipoResponsavelAlterado = () => {
      if (responsavel.value.tipo.value === "responsavel_area") {
        responsavel.value.terceirizado = false;
      }
    };

    const closeDialog = () => {
      emit("closing");
    };

    return {
      incluir,
      responsavelForm,
      responsavel,
      tipoResponsavel,
      adicionarResponsavel,
      tipoResponsavelAlterado,
      closeDialog,
      injectFuncionario,
      injectParceiro,
      parceiro,
      empresaTerceiro,
      injectTerceiro,
      listarTipoResponsaveis,
      isValidating,
      showEpiDialog,
      epiDialogProps,
      handleEpiDialogConfirm,
      handleEpiDialogCancel,
    };
  },
};
</script>

<style scoped>
.container-nowrap {
  flex-wrap: nowrap;
}
@media (max-width: 1000px) {
  .container-nowrap {
    flex-wrap: wrap;
  }
}
@media (max-width: 600px) {
  .btn {
    font-size: 12px;
  }
  .btn-acao {
    font-size: 11px !important;
  }
  .container-input {
    margin: 10px 0px 0px 0px;
  }
  .titulo-input {
    font-size: 11px;
    margin: 0px;
  }
  .select-btn {
    font-size: 16px !important;
  }
  .checkbox {
    font-size: 10px;
  }
  .container-nowrap {
    flex-wrap: wrap;
  }
}

.container-modal {
  width: 100%;
  max-width: 100%;
  overflow: hidden;
}

.container-modal .q-select {
  max-width: 100%;
  width: 100%;
}

.container-modal .col-lg-5 {
  max-width: 200px;
  min-width: 180px;
  flex: 0 0 200px;
}

.container-modal .col-lg-3 {
  max-width: 150px;
  min-width: 120px;
  flex: 0 0 150px;
}

.container-modal .col-lg-2 {
  max-width: 120px;
  min-width: 100px;
  flex: 0 0 120px;
}

.container-modal .q-field {
  max-width: 100%;
}

.container-modal .q-field__control {
  max-width: 100%;
}

.container-modal .q-field__native {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

@media (max-width: 768px) {
  .container-modal .col-lg-5,
  .container-modal .col-lg-3,
  .container-modal .col-lg-2 {
    max-width: 100%;
    flex: 1;
    margin-bottom: 10px;
  }
}
</style>
